import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_component_tooltip, { text: $props.tooltipText }, {
    default: _withCtx(() => [
      _createVNode(_component_base_button, _mergeProps(_ctx.$attrs, {
        theme: "accent",
        shape: "soft",
        display: "block",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 16 /* FULL_PROPS */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["text"]))
}